<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.4731 3.24687C10.4631 1.23687 7.45312 0.826868 5.03312 2.00687L8.66312 5.63687C9.05312 6.02687 9.05312 6.65687 8.66312 7.04687L7.07312 8.63687C6.68312 9.03687 6.05312 9.03687 5.66312 8.63687L2.03312 5.00687C0.863121 7.43687 1.27312 10.4269 3.28312 12.4369C5.14312 14.2969 7.86312 14.7869 10.1731 13.9169L18.1331 21.8769C19.1631 22.9069 20.8231 22.9069 21.8431 21.8769C22.8731 20.8469 22.8731 19.1869 21.8431 18.1669L13.9231 10.2369C14.8431 7.89687 14.3631 5.13687 12.4731 3.24687Z" 
          fill="currentColor"
    />
  </svg>
</template>

<script>

  export default {
    name: "Wrench",
  }
</script>
